import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-4 flex flex-1 grow flex-col py-4" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_skeleton = _resolveComponent("v-skeleton")

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rep, (n) => {
    return (_openBlock(), _createElementBlock("div", {
      key: n,
      class: _normalizeClass(_ctx.$attrs.class)
    }, [
      _createVNode(_component_v_skeleton, { class: "rounded-light aspect-grid-item w-full" }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_skeleton, { class: "rounded-light mb-4 block h-16 w-2/3" }),
        ($props.showPrice)
          ? (_openBlock(), _createBlock(_component_v_skeleton, {
              key: 0,
              class: "rounded-light mb-24 block h-16 w-1/3"
            }))
          : _createCommentVNode("", true),
        ($props.showAddToCart)
          ? (_openBlock(), _createBlock(_component_v_skeleton, {
              key: 1,
              class: "rounded-light mt-auto block h-16 w-1/2"
            }))
          : _createCommentVNode("", true)
      ])
    ], 2))
  }), 128))
}